// Soft UI Dashboard PRO React components
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
const headerAdjustment =
  window.location.pathname === '/dashboard' ||
  window.location.pathname === '/life-insurance'
    ? 'Update Complete!'
    : 'Onboarding Complete!'
const subHeaderAdjustment =
  window.location.pathname === '/dashboard' ||
  window.location.pathname === '/life-insurance'
    ? 'Feel free to update your information at any time'
    : 'A member of the PARCO team will be in touch soon!'

import complete from 'assets/images/onboarding/complete.png'

const CompletedOnboarding = ({
  header = headerAdjustment,
  subHeader = subHeaderAdjustment,
}) => {
  return (
    <Box sx={{ textAlign: 'left' }} pb={3}>
      <Box mb={1}>
        <Typography variant="headerTitle" color={'#262627'}>
          {header}
        </Typography>
      </Box>
      <Typography
        variant="body1"
        color={'#495057'}
        sx={{ lineHeight: '1.2' }}
        fontSize={{ xs: '16px', sm: '20px' }}
      >
        {subHeader}
      </Typography>
      <Box mt={3}>
        <img
          src={complete}
          style={{
            width: '100%',
            maxWidth: '350px',
            display: 'block',
            margin: 'auto',
          }}
        />
      </Box>
    </Box>
  )
}

export default CompletedOnboarding
